export default __webpack_public_path__ + "img/tree.9723370d.jpg";